import NotificationViewModel from "./NotificationViewModel";

export default class MarkAllViewModel {
    public notifications: NotificationViewModel[] = [];

    constructor(notifications: NotificationViewModel[]) {
        this.notifications = notifications;
    }
}